<script>
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import PriTama05 from './PriTama05.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ PriTama05 ],
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
    </template>

    <template #col2>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(7 * 4)" />
    </template>

    <template #col3>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(7 * 4)" :isOrphan="true" />
    </template>

    <template #col4>
      <Status :date="date" :items="items" :showNico="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: 50px;
  //   }
  // }
</style>
